import { UseMutationOptions, useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { DocumentRequestStatus } from '@/types'
import { AxiosError } from 'axios'

type Params = {
  document_request_key: string
  status: DocumentRequestStatus
  observation?: string
  no_financial_movement?: boolean
}

export async function updateDocumentRequestStatus(params: Params) {
  const response = await httpClient('accounting-dealer').put(
    '/v3/file/document-request/status',
    params,
  )

  return response.data
}

export function useUpdateDocumentRequestStatus(
  options?: UseMutationOptions<unknown, AxiosError, Params, unknown>,
) {
  return useMutation({
    mutationFn: updateDocumentRequestStatus,
    ...options,
  })
}
